import { Grid, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Namespace } from '../../../locales/translations';
import { AwarenessCampaignData } from '../../../models/AwarenessCampaign';
import AwarenessCampaignCard from '../AwarenessCampaignCard';

interface CampaignGridProps {
    missions: AwarenessCampaignData[];
    showAmbassadorCompleted: boolean;
}

const CampaignGrid = ({ missions, showAmbassadorCompleted }: CampaignGridProps) => {
    const { t } = useTranslation([Namespace.ADDRESSES]);

    return (
        <Grid container spacing={3} padding={2} paddingTop={0} paddingBottom={8}>
            {missions.length > 0 ? (
                missions.map(mission => (
                    <Grid key={mission.ID} item xs={12} sm={6} md={3} lg={2}>
                        <AwarenessCampaignCard missionData={mission} />
                    </Grid>
                ))
            ) : (
                <Grid item xs={12}>
                    <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
                        <Typography variant="h6" textAlign="center">
                            {showAmbassadorCompleted 
                                ? t('no_completed_campaigns', { ns: Namespace.ADDRESSES })
                                : t('no_pending_campaigns', { ns: Namespace.ADDRESSES })}
                        </Typography>
                    </Box>
                </Grid>
            )}
        </Grid>
    );
};

export default CampaignGrid; 